import PropTypes from "prop-types";
import Toast from "react-bootstrap/Toast";
import { useDispatch } from "react-redux";
import { removeNotification } from "../../redux/notifications";

const Notification = ({ id, type, header, message }) => {
    const dispatch = useDispatch();
    type = type ?? "success";

    return (
        <Toast
            key={id}
            autohide
            delay={5000}
            className={type}
            onClose={() => dispatch(removeNotification(id))}
        >
            { header && <Toast.Header className={type}>
                <span className={`icon ${type}`}></span>
                <p className="toast-header-text">{header}</p>
            </Toast.Header>}
            <Toast.Body className={type}>
                <p className="toast-body-text">{message}</p>
            </Toast.Body>
        </Toast>
    );
};

Notification.propTypes = {
    id: PropTypes.string.isRequired,
    header: PropTypes.string,
    message: PropTypes.string.isRequired,
    type: PropTypes.string,
};

export default Notification;